import React from 'react';
import MuiTabs, { TabsProps as MuiTabsProps } from '@mui/material/Tabs';

/**
 * Pioneer Tabs — wraps MUI Tabs with project defaults.
 *
 * Defaults:
 * - indicatorColor="primary" (Pioneer standard)
 * - textColor="primary" (Pioneer standard)
 *
 * All MUI Tabs props are supported and can override defaults.
 */
export type TabsProps = MuiTabsProps;

const Tabs = React.forwardRef<React.ElementRef<typeof MuiTabs>, TabsProps>(
  function Tabs(props, ref) {
    return <MuiTabs indicatorColor="primary" textColor="primary" ref={ref} {...props} />;
  },
);

export default Tabs;
